wbApp.controller('ActivityReconciliationRecurringInvoicesCtrl', ['$q', '$scope', '$modal', 'invoiceRecurrenceScheduleSvc',
function ($q, $scope, $modal, invoiceRecurrenceScheduleSvc) {

    $scope.semesterID = null;
    $scope.activityID = null;
    $scope.studentID = null;

    var isActive = false;
    var loaded = false;

    function loadData(semesterID, activityID, studentID) {
        if ($scope.activityID && $scope.studentID) {
            $scope.recurringInvoices = invoiceRecurrenceScheduleSvc.getAllForStudentAndActivity(semesterID, studentID, activityID);
            loaded = true;
        } else {
            loaded = false;
            $scope.recurringInvoices = null;
        }
    }

    $scope.$on('activeTabChanged', function (e, data) {
        if (data.activeTab === 3) {
            if (!isActive) {
                isActive = true;
                if (!loaded) {
                    loadData($scope.semesterID, $scope.activityID, $scope.studentID);
                }
            }
        } else {
            isActive = false;
        }
    });

    $scope.$on('activityStudentSelectionChanged', function (e, data) {
        if (data.studentID != $scope.studentID ||
            data.activityID != $scope.activityID ||
            data.reasonCode == 'activityReconciliationChanged') {
            $scope.semesterID = data.semesterID;
            $scope.activityID = data.activityID;
            $scope.studentID = data.studentID;
            $scope.studentFullName = data.studentFullName;

            if (isActive) {
                loadData($scope.semesterID, $scope.activityID, $scope.studentID);
            } else {
                loaded = false;
            }
        }
    });


    $scope.acivityReconciliationRecurringInvoiceFilterOptions = {
        filterText: ""
    };

    $scope.acivityReconciliationRecurringInvoicesGridOptions = {
        sortInfo: { fields: ['reconciledAt'], directions: ['asc'] },
        columnDefs: [
            { field: 'active', displayName: "TXT_LBL_ACTIVE", cellFilter: 'checkmark', width: '70px' },
            { field: 'name', displayName: "TXT_LBL_NAME" },
            { field: 'repeatEveryNoOfUnits', displayName: "TXT_LBL_REPEAT_EVERY", width: '110px' },
            { field: 'reccurenceUnitTypeID', displayName: "", cellFilter: 'wbRecurrenceUnitTypeFlt', width: '130px' },
            { field: 'startDate', cellFilter: "date:'shortDate'", displayName: "TXT_LBL_START_DATE", width: '90px' },
            { field: 'endDate', cellFilter: "date:'shortDate'", displayName: "TXT_LBL_END_DATE", width: '90px' },
            { field: 'nextInvoice', cellFilter: "date:'shortDate'", displayName: "TXT_LBL_NEXT_ISSUE", width: '110px' },
            { field: 'invoiceTotal', cellFilter: "wbCurrencyFlt", displayName: "TXT_LBL_SUMMARY", align: 'right', width: '110px' }
        ],
        disabledField: 'notActive',
        disabledAreSelectable: true,
    }

    $scope.onRowEdit = function (data) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = angular.copy(data);
            detailDialogPromise.$scope.onScheduleSave = function () {
                loadData($scope.semesterID, $scope.activityID, $scope.studentID);
            }
            detailDialogPromise.show();
        });
    }

    $scope.onRowAdd = function () {

        var model = invoiceRecurrenceScheduleSvc.createNew(
                $scope.semesterID, $scope.studentID,  $scope.activityID);

        $q.all([detailDialogPromise.$promise, model.$promise]).then(function () {
            detailDialogPromise.$scope.model = model;
            detailDialogPromise.$scope.onScheduleSave = function () {
                loadData($scope.semesterID, $scope.activityID, $scope.studentID);
            }
            detailDialogPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        invoiceRecurrenceScheduleSvc.remove(data, function () {
            loadData($scope.semesterID, $scope.activityID, $scope.studentID);
        });
    }

    $scope.recurringInvoices = [];

    var detailDialogPromise = $modal({
        templateUrl: 'activities/activity-reconciliation/recurring-invoice-detail.html',
        show: false,
        scope: $scope.$new()
    });

}]);